<template>

  <div>
    <PageHeader :title="'Share ' + (chapter ? chapter.title : 'Chapter')"></PageHeader>

    <div class="main-content container-fluid xs-pt-0">
      <div class="row">
        <div class="col-xs-12">
          <Panel class="panel panel-default panel-border-color panel-border-color-primary xs-mt-0">
            <PanelBody v-if="chapter" class="xs-pt-20 xs-pb-20">
              <div class="xs-mb-20 text-bold">Enter the email address of the users you would like to share with.</div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <label class="sm-pt-10" for="txtEmail">Search on email address</label>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-9">
                  <div class="input-group">
                    <input type="email" id="txtEmail" class="form-control pull-left" placeholder="enter email address" v-model="searchEmail" />
                    <div class="input-group-addon"><button class="btn btn-primary btn-xl" v-on:click="searchUser()" :disabled="!emailValid || searching">Search</button></div>
                  </div>

                  <div class="search-results" v-if="userSearchResults.length > 0">
                    <table>
                      <tr v-for="user in userSearchResults">
                        <td class="email">{{user.email}}</td>
                        <td style="width:50px;"><button class="btn btn-primary btn-sm" v-on:click="addEmail(user)"><i class="fas fa-plus"></i></button></td>
                      </tr>
                    </table>
                  </div>
                  <div class="search-results no-results" v-if="showNoResultsMessage">
                    No users found with this email address.
                  </div>
                </div>
              </div>
              <div v-if="sharingEmails.length > 0">
                <hr />
                <strong>Sharing '{{chapter.title}}' with:</strong>

                <div class="row sharing-emails">
                  <div class="col-xs-12 col-sm-6">
                    <table>
                      <tr v-for="user in sharingEmails">
                        <td>{{user.email}}</td>
                        <td><button class="btn btn-danger btn-sm" v-on:click="removeEmail(user)"><i class="fas fa-times"></i></button></td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <button class="pull-right btn btn-primary btn-xl" v-on:click="share()" :disabled="sharingEmails.length <= 0">Share with {{sharingEmails.length}} user{{sharingEmails.length > 1 ? 's' : ''}}</button>
                  </div>
                </div>
              </div>
            </PanelBody>
            <PanelBody v-else  class="xs-pt-20 xs-pb-20">
              <div class="alert alert-warning">No chapter selected</div>
            </PanelBody>
          </Panel>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.div -->
</template>
<script>
  import _ from 'underscore'
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
      
  },
  created() {
    this.getChapters();
    this.$store.dispatch('clearSearch');
  },
  methods: {
    ...mapActions([
      'getChapters',
    ]),
    addEmail(user) {
      const current = _.where(this.sharingEmails, { email: user.email });

      // user in list
      if (current.length > 0) {
        Toast.error('User is already in share list.');
        return;
      }

      // sharing off
      if (!user.AllowSharing) {
        Toast.error('User has sharing turned off. Cannot share with this user.');
        return;
      }

      // ok
      this.sharingEmails.push(user);
      this.searchEmail = '';
      this.$store.dispatch('clearSearch');
    },
    removeEmail(user) {
      for (let i = 0; i < this.sharingEmails.length; i++) {
        if (this.sharingEmails[i].email == user.email) {
          this.sharingEmails.splice(i, 1);
          break;
        }
      }
    },
    searchUser() {
      this.searching = true;
      this.$store.dispatch('searchUsers', { searchTerm: this.searchEmail, callback: this.searchComplete});
    },
    searchComplete() {
      this.searching = false;
    },
    share() {
      if (this.sharingEmails.length > 0) {
        this.leftToShare = this.sharingEmails.length;
        for (let u of this.sharingEmails) {
          var share = { recipient_uid: u.uid, chapter_id: this.chapter.id };
          this.$store.dispatch('shareChapter', { share: share, callback: this.shareComplete });
        }
      }
    },
    shareComplete() {
      this.leftToShare -= 1;
      if (this.leftToShare <= 0) {
        Toast.success('Chapter shared with users.');
        this.sharingEmails = [];
      }
    },
  },
  data() {
    return {
      searchEmail: '',
      sharingEmails: [],
      searching: false,
      leftToShare: 0
    }
  },
  computed: {
    ...mapGetters({
      userSearchResults: 'userSearchResults',
      showNoResultsMessage: 'showNoResultsMessage',
    }),
    ...mapState([
      'currentUser',
    ]),
    chapter() {
      return this.$store.state.chapters[this.$route.params.chapterId];
    },
    emailValid() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.searchEmail).toLowerCase());
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .active-toggle {float:right;font-size:14px;margin-top:10px;margin-right:40px;}
  .input-group .input-group-addon { padding:0px;background:none;border:0px;}
  .input-group .input-group-addon .btn {border-radius:0px 2px 2px 0px;line-height:46px;}

  .search-results {border:1px solid #DDDDDD;border-top:0px;}
  .search-results table {width:100%;}
  .search-results table td {padding:10px;}
  .no-results {padding:10px;}

  .sharing-emails {margin-top:20px;}
  .sharing-emails td {padding:10px;}
</style>



// WEBPACK FOOTER //
// ChapterSharer.vue?ccd2295a